import React, { useEffect, useState, useContext} from "react";
import { useParams, useHistory } from "react-router-dom";
import Input from "../../shared/components/formElements/Input";
import Button from "../../shared/components/formElements/Button";
import Card from "../../shared/components/UIElements/Card";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import {
  VALIDATOR_MAXLENGTH,
  VALIDATOR_NOT_REQUIRE,
  VALIDATOR_REQUIRE,
  VALIDATOR_NUMERIC,
  VALIDATOR_MAX,
  VALIDATOR_SPECIAL_CHARACHTER,
} from "../../shared/util/validators";
import { useForm } from "../../shared/hooks/form-hook";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AuthContext } from '../../shared/context/auth-context';
import "./SendBacks.css";

const UpdateSendBack = () => {

  const auth = useContext(AuthContext);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [loadedSendBack, setLoadedSendBack] = useState();
  const sendBacksID = useParams().sendbacksId;
  const history = useHistory();

  const [formState, inputHandler, setFormData] = useForm(
    {
      style: {
        value: "",
        isValid: false,
      },
      company: {
        value: "",
        isValid: false,
      },
      color: {
        value: "",
        isValid: false,
      },
      USSize: {
        value: "",
        isValid: false,
      },
      EURSize: {
        value: "",
        isValid: true,
      },
      quantity: {
        value: "",
        isValid: true,
      },
      cost: {
        value: "",
        isValid: true,
      },
      price: {
        value: "",
        isValid: true,
      },
      website: {
        value: "",
        isValid: true,
      },
      description: {
        value: "",
        isValid: true,
      },
    },
    false
  );

  useEffect(() => {
    const fetchSendBack = async () => {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+`/sendBacks/${sendBacksID}`,
          "GET",
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setLoadedSendBack(responseData.sendBack);
        setFormData(
          {
            style: {
              value: responseData.sendBack.style.split("_")[0],
              isValid: true,
            },
            company: {
              value: responseData.sendBack.company,
              isValid: true,
            },
            color: {
              value: responseData.sendBack.color,
              isValid: true,
            },
            USSize: {
              value: responseData.sendBack.USSize,
              isValid: true,
            },
            EURSize: {
              value: responseData.sendBack.EURSize,
              isValid: true,
            },
            quantity: {
              value: responseData.sendBack.quantity,
              isValid: true,
            },
            cost: {
              value: responseData.sendBack.cost,
              isValid: true,
            },
            price: {
              value: responseData.sendBack.price,
              isValid: true,
            },
            website: {
              value: responseData.sendBack.website,
              isValid: true,
            },
            description: {
              value: responseData.sendBack.description,
              isValid: true,
            },
          },
          true
        );
      } catch (err) {}
    };
    fetchSendBack();
  }, [sendRequest, sendBacksID, setFormData, auth.token]);


  
  const placeUpdateSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+`/sendBacks/${sendBacksID}/edit`,
        "PATCH",
        JSON.stringify({
          style:
            formState.inputs.style.value.split("_")[0] +
            "_" +
            formState.inputs.color.value +
            "_" +
            formState.inputs.USSize.value,
          company: (formState.inputs.company.value).toUpperCase().trim(),
          color: formState.inputs.color.value,
          USSize: formState.inputs.USSize.value,
          EURSize: formState.inputs.EURSize.value,
          quantity: formState.inputs.quantity.value,
          cost: formState.inputs.cost.value,
          price: formState.inputs.price.value,
          website: formState.inputs.website.value,
          description: formState.inputs.description.value,
        }),
        {
          "Content-Type": "application/json",
          Authorization: 'Bearer '+ auth.token
        }
      );
      history.push(`/sendBacks/${sendBacksID}`);
    } catch (err) {}
  };
  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }
  if (!loadedSendBack && !error) {
    return (
      <div className="center">
        <Card>
          <h2>Could not find the send back Item!</h2>
        </Card>
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {!isLoading && loadedSendBack && (
        <div className="sendBack-Items-list">
          <Card className="sendBack-item__content" >
            <h2 className="header-text-sendBack">Edit Send Back</h2>
            <form className="sendBack-form" onSubmit={placeUpdateSubmitHandler}>
              <div className="flex justify-center">
                <div className=" w-50 mr1">
                  <code>
                    <Input
                      id="style"
                      element="input"
                      type="text"
                      label="Style"
                      validators={[
                        VALIDATOR_REQUIRE(),
                        VALIDATOR_MAXLENGTH(23),
                        VALIDATOR_SPECIAL_CHARACHTER()
                      ]}
                      errorText="Please enter a valid (Less than 23 characters) style."
                      onInput={inputHandler}
                      initialValue={formState.inputs.style.value}
                      initialValid={formState.inputs.style.isValid}
                    />
                  </code>
                </div>
                <div className=" w-50 ml2 mr1">
                  <code>
                    <Input
                      id="company"
                      element="input"
                      type="text"
                      label="Company"
                      validators={[
                        VALIDATOR_REQUIRE(),
                        VALIDATOR_MAXLENGTH(23),
                        VALIDATOR_SPECIAL_CHARACHTER()
                      ]}
                      errorText="Please enter a valid (Less than 23 characters) company."
                      onInput={inputHandler}
                      initialValue={formState.inputs.company.value}
                      initialValid={formState.inputs.company.isValid}
                    />
                  </code>
                </div>
              </div>
              <div className="flex justify-center">
                <div className="w-50  mr1">
                  <code>
                    <Input
                      id="color"
                      element="input"
                      type="text"
                      label="Color"
                      validators={[
                        VALIDATOR_REQUIRE(),
                        VALIDATOR_MAXLENGTH(20),
                        VALIDATOR_SPECIAL_CHARACHTER()
                      ]}
                      errorText="Please enter less than 20 characters."
                      onInput={inputHandler}
                      initialValue={formState.inputs.color.value}
                      initialValid={formState.inputs.color.isValid}
                    />
                  </code>
                </div>
                <div className=" w-50 ml2 mr1">
                  <code>
                    <Input
                      id="quantity"
                      element="input"
                      type="number"
                      label="Quantity"
                      /// add validator for numeric entries
                      validators={[
                        VALIDATOR_REQUIRE(),
                        VALIDATOR_NUMERIC(),
                        VALIDATOR_MAX(31),
                      ]}
                      errorText="Please enter a valid quantity."
                      onInput={inputHandler}
                      initialValue={formState.inputs.quantity.value}
                      initialValid={formState.inputs.quantity.isValid}
                    />
                  </code>
                </div>
              </div>
              <div className="flex justify-center">
                <div className=" w-50  mr1">
                  <code>
                    <Input
                      id="USSize"
                      element="input"
                      type="text"
                      label="US Size"
                      validators={[
                        VALIDATOR_REQUIRE(),
                        VALIDATOR_MAXLENGTH(20),
                        VALIDATOR_SPECIAL_CHARACHTER(),
                      ]}
                      errorText="Please enter a valid US size."
                      onInput={inputHandler}
                      initialValue={formState.inputs.USSize.value}
                      initialValid={formState.inputs.USSize.isValid}
                    />
                  </code>
                </div>
                <div className=" w-50 ml2 mr1">
                  <code>
                    <Input
                      id="EURSize"
                      element="input"
                      type="text"
                      label="EUR Size"
                      validators={[
                        VALIDATOR_REQUIRE(),
                        VALIDATOR_MAXLENGTH(20),
                        VALIDATOR_SPECIAL_CHARACHTER(),
                      ]}
                      errorText="Please enter a valid EUR size."
                      onInput={inputHandler}
                      initialValue={formState.inputs.EURSize.value}
                      initialValid={formState.inputs.EURSize.isValid}
                    />
                  </code>
                </div>
              </div>
              <div className="flex justify-center">
                <div className=" w-50  mr1">
                  <code>
                    <Input
                      id="cost"
                      element="input"
                      type="number"
                      label="Cost"
                      validators={[VALIDATOR_REQUIRE(), VALIDATOR_NUMERIC()]}
                      errorText="Please enter a valid cost."
                      onInput={inputHandler}
                      initialValue={formState.inputs.cost.value}
                      initialValid={formState.inputs.cost.isValid}
                    />
                  </code>
                </div>
                <div className=" w-50 ml2 mr1">
                  <code>
                    <Input
                      id="price"
                      element="input"
                      type="number"
                      label="Price"
                      validators={[VALIDATOR_REQUIRE(), VALIDATOR_NUMERIC()]}
                      errorText="Please enter a valid price."
                      onInput={inputHandler}
                      initialValue={formState.inputs.price.value}
                      initialValid={formState.inputs.price.isValid}
                    />
                  </code>
                </div>
              </div>
              <div className="flex justify-center">
                <div className=" w-50  mr1">
                  <code>
                    <Input
                      id="website"
                      element="input"
                      type="text"
                      label="Website"
                      validators={[VALIDATOR_NOT_REQUIRE()]}
                      onInput={inputHandler}
                      initialValue={formState.inputs.website.value}
                      initialValid={formState.inputs.website.isValid}
                    />
                  </code>
                </div>
                <div className=" w-50 ml2 mr1">
                  <code>
                    <Input
                      id="description"
                      element="input"
                      type="text"
                      label="description"
                      validators={[VALIDATOR_NOT_REQUIRE()]}
                      onInput={inputHandler}
                      initialValue={formState.inputs.description.value}
                      initialValid={formState.inputs.description.isValid}
                    />
                  </code>
                </div>
              </div>

              <Button type="submit" disabled={!formState.isValid}>
                UPDATE
              </Button>
              <Button inverse to={`/sendBacks/${sendBacksID}`}>
                CANCEL
              </Button>
            </form>
          </Card>
        </div>
      )}
    </React.Fragment>
  );
};


export default UpdateSendBack;